import React from 'react'
import { useNavigate } from 'react-router-dom'
import GlassPanel from '../components/UI/GlassPanel'
import StatusMessage from '../components/UI/StatusMessage'
import StepIndicator from '../components/StampForm/StepIndicator'
import EventSelector from '../components/StampForm/EventSelector'
import PhotoUploadSection from '../components/StampForm/PhotoUploadSection'
import { useStampForm } from '../hooks/useStampForm'

const AddStamp = () => {
  const navigate = useNavigate()
  const {
    currentStep,
    userEvents,
    selectedEvent,
    selectedFile,
    previewUrl,
    uploading,
    error,
    success,
    handleEventSelect,
    handleFileSelect,
    handleStampSubmit,
    resetToEventSelection
  } = useStampForm()

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 py-8">
      <div className="max-w-4xl mx-auto px-4">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-white mb-2">
                Add Stamp to Passport
              </h1>
              <p className="text-gray-300">
                {currentStep === 'select-event'
                  ? 'Select an event to add a stamp for'
                  : 'Upload your festival stamp photo'
                }
              </p>
            </div>
            <button
              onClick={() => navigate('/passport')}
              className="bg-white/10 hover:bg-white/20 text-white font-medium py-2 px-4 rounded-lg border border-white/20 hover:border-white/40 transition-all duration-300"
            >
              ← Back to Passport
            </button>
          </div>
        </div>

        <StepIndicator currentStep={currentStep} />

        <GlassPanel className="p-8">
          {currentStep === 'select-event' && (
            <EventSelector
              userEvents={userEvents}
              onEventSelect={handleEventSelect}
            />
          )}

          {currentStep === 'upload-photo' && selectedEvent && (
            <PhotoUploadSection
              selectedEvent={selectedEvent}
              selectedFile={selectedFile}
              previewUrl={previewUrl}
              uploading={uploading}
              onFileSelect={handleFileSelect}
              onSubmit={handleStampSubmit}
              onReset={resetToEventSelection}
            />
          )}

          <StatusMessage type="error" message={error} />
          <StatusMessage type="success" message={success} />
        </GlassPanel>
      </div>
    </div>
  )
}

export default AddStamp